import * as React from 'react'
import './styles.css'

interface Props {
  children: JSX.Element
}
export const DetailPanel = ({children}: Props) => <div className="detail-panel">
  {children}
</div>



// WEBPACK FOOTER //
// ./src/components/detail-panel/component.tsx